import React from 'react';

const transformDataStructure = (originalData) => {
  if (!originalData || !originalData.inputList) {
    return { inputList: [], formula: {}, condition: {} };
  }

  const groupedByStep = {};
  
  originalData.inputList.forEach(item => {
    const stepIndex = item.StepIndex || 0;
    
    if (!groupedByStep[stepIndex]) {
      groupedByStep[stepIndex] = {
        stepItem: null,
        items: []
      };
    }
    
    if (item.type === 14 && item.typeName === 'Step') {
      groupedByStep[stepIndex].stepItem = item;
    } else {
      groupedByStep[stepIndex].items.push(item);
    }
  });

  const transformedInputList:any = [];
  
  Object.keys(groupedByStep)
    .sort((a, b) => Number(a) - Number(b))
    .forEach(stepIndex => {
      const group = groupedByStep[stepIndex];
      
      if (group.stepItem) {
       
        
        const newStepItem:any = {
          type: 18,
          typeName: 'Card',
          stepNumber: +stepIndex,
          inputList: group.items.map(item => {
            const { StepIndex, ...itemWithoutStepIndex } = item;
            return {
              ...itemWithoutStepIndex,
              StepIndex: 0 
            };
          }),
          backendType: group.stepItem.backendType || '',
          size: group.stepItem.size || '12',
          label: group.stepItem.label,
          SystemKey: group.stepItem.SystemKey,
          hidden: group.stepItem.hidden || false
        };
         console.log("stepIndex " ,newStepItem);
         if (group.stepItem.initialSystemKey) {
          newStepItem.initialSystemKey = group.stepItem.initialSystemKey;
        }
        
        transformedInputList.push(newStepItem);
      } else if (group.items.length > 0) {
        group.items.forEach(item => {
          transformedInputList.push(item);
        });
      }
    });

  const transformedData = {
    inputList: transformedInputList,
    formula: originalData.formula || {},
    condition: originalData.condition || {}
  };

  return transformedData;
};

export { transformDataStructure };